/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  OverlayTrigger,
  FormControl,
  ControlLabel,
  FormGroup,
  Pagination,
  Tooltip,
} from "react-bootstrap";
import {
  searchHealthcondition,
  deletehealthcondition,
  getMedicationcategory,
  getCity,
  searchMedication,
  AddMedicationbulkfile,
  exportmedicationfile,
} from "../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import { Link, withRouter } from "react-router-dom";
import ReactTable from "react-table";
import LoadingSpinner from "views/Components/loadingSpinner";

import SweetAlert from "react-bootstrap-sweetalert";

import Switch from "react-bootstrap-switch";

import Card from "components/Card/Card.jsx";

import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
class viewhealthcondition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      medication_detail: [],
      healthcondition_detail: [],
      category: [],
      healthconditionname: "",
      paginationData: [],
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      loading: false,
      tabledata: [],
      page: "",
      _notificationSystem: null,
      alert: null,
      useraccess: "",
      medicationfile: null,
      city: "0",
      showbulkui: 0,
      noRecordFound: false,

      city_info: [],
    };
    this.fileInput = React.createRef();
    this.submitbulkmedication = this.submitbulkmedication.bind(this);
    this.selectedhealthconsition = this.selectedhealthconsition.bind(this);
    this.deletehealthcondition = this.deletehealthcondition.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.searchdata = this.searchdata.bind(this);
    this.searchData = this.searchData.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.addbulkmedication = this.addbulkmedication.bind(this);
    // this.onChange = this.onChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
  }
  selectedhealthconsition(helthcondi) {
    // console.log(cus);
    localStorage.setItem("healthcondition_id", JSON.stringify(helthcondi));

    this.props.history.push("/admin/edit_healthcondition");
  }
  async componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    this.searchData();
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;
    this.setState({
      useraccess: token.role,
    });
  }
  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };
  paginationinfo(url) {
    this.setState({ page: url });
    this.searchData();
  }
  searchdata(e) {
    this.setState({ page: "" });
    this.searchData();
  }
  resetSearch(e) {
    this.setState({ healthconditionname: "" });
    this.searchData();
  }
  subStrAfterChars(str, char, pos) {
    if (pos == "b") return str.substring(str.indexOf(char) + 1);
    else if (pos == "a") return str.substring(0, str.indexOf(char));
    else return str;
  }
  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;
    this.setState({ noRecordFound: false });

    // console.log(this.state.itemcode,this.state.description,this.state.price,this.state.medicationcategory,this.state.commision,this.state.unitprice,this.state.page)
    this.setState({ loading: true }, () => {
      searchHealthcondition(
        this.state.healthconditionname,
        this.state.page,
        obj
      )
        .then((response1) => {
          var data = response1.data;
          console.log(data);
          if (data.data.length == 0) {
            this.setState({ noRecordFound: true });
          }
          // console.log(data.next_page_url);
          // console.log(data,data.last_page);
          var $no_pages = [];
          let serach_string = "";
          for (var i = 1; i <= data.last_page; i++) {
            if (serach_string == "") {
              $no_pages.push(i);
            } else {
              $no_pages.push(i);
            }
          }

          if (data.current_page == data.last_page) {
            this.setState({ prevdisabled: null });
            this.setState({ nextdisabled: "1" });
          } else if (data.current_page == 1) {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: "1" });
          } else {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: null });
          }
          if (data.last_page == 1) {
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          if (data.data.length == 0) {
            $no_pages = [];
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          this.setState({ currentPage: data.current_page });
          console.log(data.next_page_url, "next page url");
          console.log(data.prev_page_url, "prev page url");
          if (data.next_page_url != null) {
            console.log(
              this.subStrAfterChars(data.next_page_url, "=", "b"),
              "new pattern"
            );
            if (serach_string == "") {
              this.setState({
                nextpage: this.subStrAfterChars(data.next_page_url, "=", "b"),
              });
            } else {
              this.setState({
                nextpage: this.subStrAfterChars(data.next_page_url, "=", "b"),
              });
            }
          } else {
            console.log("in else");
            this.setState({ nextpage: "#" });
          }
          if (data.prev_page_url != null) {
            if (serach_string == "") {
              this.setState({
                prevpage: this.subStrAfterChars(data.prev_page_url, "=", "b"),
              });
            } else {
              this.setState({
                prevpage: this.subStrAfterChars(data.prev_page_url, "=", "b"),
              });
            }
          } else {
            console.log("in else 2");

            this.setState({ prevpage: "#" });
          }
          this.setState({ paginationData: $no_pages });

          this.setState({
            loading: false,
            healthcondition_detail: data.data,
          });
        })
        .catch((error) => {
          console.log(error, "== error");
          this.handleNetworkError("bl");
        });
    });
  }
  warningWithConfirmAndCancelMessage(id) {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deletehealthcondition(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this Health Condition Detail !
        </SweetAlert>
      ),
    });
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  addbulkmedication() {
    this.setState({
      showbulkui: 1,
    });
  }
  closemedicatonupload() {
    this.setState({
      showbulkui: 0,
    });
  }
  exportfile() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    exportmedicationfile(obj).then((res) => {});
  }
  handleInputChange(event) {
    // let file = event.target.files[0]
    // console.log(file)
    // this.setState({ medicationfile: event.target.files[0] });
    // this.setState({
    //   medicationfile: file
    //   })
  }
  submitbulkmedication() {
    // var token = JSON.parse(localStorage.getItem('user'));
    // const  obj = token.token
    // const file_data = this.state.medicationfile;
    // console.log(file_data,'file data')
    // const data = new FormData();
    // data.append('myFile',file_data)
    // // alert(`selected file - ${this.fileInput.current.files[0]}`)
    // // console.log(formdata)
    // AddMedicationbulkfile(data,obj)
    // .then((res)=>{
    //     alert(res);
    // })
    // .then(error => {
    //   console.log(error)
    // })
  }

  deletehealthcondition(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;

    deletehealthcondition(id, obj)
      .then(() => {
        // alert('category deleted');
        // window.location.href="#/admin/medication-category";
        this.setState({
          alert: null,
        });
        this.searchData();
      })
      .catch((error) => {
        console.log(error, "== error");
        this.handleNetworkError("bl");
      });
  }
  addhealthcondition() {
    this.props.history.push("/admin/add_healthcondition");
  }

  render() {
    const view = <Tooltip id="view">View Profile</Tooltip>;
    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;

    const hc = this.state.healthcondition_detail;
    console.log(hc);
    var c = 1;

    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={12}>
              <Card
                tableFullWidth
                content={
                  <Row>
                    {this.state.useraccess == 3 ? (
                      ""
                    ) : (
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          className="text-right"
                        >
                          <Button
                            className="fl_mb_web_1 btn-fill fl_mb_1 w_150 "
                            class="btn-color"
                            fill
                            onClick={this.addhealthcondition.bind(this)}
                          >
                            Health Condition <i className="fa fa-plus"></i>
                          </Button>
                          &nbsp;
                          {/* <Button  className="fl_mb_web_1 btn-fill fl_mb_1 w_150 " onClick={this.addbulkmedication.bind(this)}  bsStyle="info" fill  >Add Bulk Medication</Button> */}
                        </Col>
                        {/* {this.state.showbulkui == 1 ? 
                    <Col xs={12} sm={12} md={12} lg={12} > 
                    <h5>Upload Medication details</h5>
                    <form>
                      <FormGroup>
                      <ControlLabel>Bulk Medication</ControlLabel>
                      <input type="file"  name="medicationfile" onChange={this.handleInputChange}  placeholder="select file" />
                      </FormGroup>
                      <FormGroup>
                        <Button fill onClick={this.submitbulkmedication.bind(this)} bsStyle="success">Submit</Button>
                        &nbsp;
                        <Button fill  onClick={this.closemedicatonupload.bind(this)} bsStyle="danger">close</Button>
                        &nbsp;
                        <Button fill  onClick={this.exportfile.bind(this)} bsStyle="danger">export</Button>
                        
                      </FormGroup>
                    </form>
                    </Col>
                    : ''} */}
                      </Col>
                    )}
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <Col md={3} sm={3} lg={3} xs={12} className="fl_mb_1 ">
                        <FormControl
                          name="healthconditionname"
                          value={this.state.healthconditionname || ""}
                          placeholder="Health Condition"
                          onChange={this.onChange}
                          type="text"
                        />
                      </Col>

                      <Col
                        md={2}
                        sm={2}
                        lg={2}
                        xs={12}
                        className="fl_mb_1 w_150 no-padding"
                      >
                        <Button
                          class="btn-color"
                          fill
                          onClick={this.searchdata.bind(this)}
                        >
                          Filter
                        </Button>
                        &nbsp;&nbsp;
                        <Button
                          class="btn-color"
                          fill
                          onClick={this.resetSearch.bind(this)}
                        >
                          Reset
                        </Button>
                      </Col>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Health Condition </th>
                            <th>Display in App</th>
                            {this.state.useraccess == 3 ? (
                              ""
                            ) : (
                              <th className="text-right">Actions</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading ? (
                            <tr>
                              <td colspan="10">
                                <LoadingSpinner />
                              </td>
                            </tr>
                          ) : this.state.noRecordFound ? (
                            <tr>
                              <td colspan="10">
                                <center>No record found</center>
                              </td>
                            </tr>
                          ) : (
                            <React.Fragment>
                              {hc.map((cus) => (
                                <tr>
                                  <td>{cus.healthconditionname}</td>
                                  <td>
                                    {cus.show_in_app == "1" ? "Yes" : "No"}
                                  </td>
                                  {this.state.useraccess == 3 ? (
                                    ""
                                  ) : (
                                    <td className="td-actions text-right">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={edit}
                                      >
                                        <Button
                                          simple
                                          bsStyle="success"
                                          onClick={this.selectedhealthconsition.bind(
                                            this,
                                            cus.id
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-edit" />
                                        </Button>
                                      </OverlayTrigger>
                                      {this.state.useraccess == 1 && (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={remove}
                                        >
                                          <Button
                                            simple
                                            bsStyle="danger"
                                            onClick={this.warningWithConfirmAndCancelMessage.bind(
                                              this,
                                              cus.id
                                            )}
                                            bsSize="xs"
                                          >
                                            <i className="fa fa-times" />
                                          </Button>
                                        </OverlayTrigger>
                                      )}
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </React.Fragment>
                          )}
                        </tbody>
                      </Table>
                      {this.state.loading ? (
                        ""
                      ) : this.state.noRecordFound ? (
                        ""
                      ) : (
                        <div style={{ textAlign: "center" }}>
                          <Pagination>
                            <Pagination.First
                              dataUrl={this.state.prevpage}
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.prevpage
                              )}
                              disabled={this.state.prevdisabled}
                            />
                            {this.state.paginationData.map((url) => (
                              <Pagination.Item
                                dataUrl={url}
                                active={
                                  this.state.currentPage == c ? "1" : null
                                }
                                onClick={this.paginationinfo.bind(this, url)}
                              >
                                {c++}
                              </Pagination.Item>
                            ))}
                            <Pagination.Last
                              dataUrl={this.state.nextpage}
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.nextpage
                              )}
                              disabled={this.state.nextdisabled}
                            />
                          </Pagination>
                        </div>
                      )}
                    </Col>
                  </Row>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default viewhealthcondition;
